import React, { Component } from 'react';
import { ContactFormFullwidth } from 'components';
import { enableAnimations } from 'config/helpers';
import {
  Banner,
  BusinessConsultants,
  Experts,
  Workspace,
  SocialMedia,
  OurEvents,
} from './subcomponents';
import './Connect.scss';

class Contact extends Component {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    return (
      <div className={'single-page single-page--hero connect-page'}>
        <Banner />
        <BusinessConsultants />
        <Experts />
        <ContactFormFullwidth
          id={'form'}
          name={'connect-contact-form'}
          pardotLink={'https://go.boldare.com/l/688533/2019-02-28/x5r'}
        />
        <Workspace />
        <SocialMedia />
        <OurEvents />
      </div>
    );
  }
}

export default Contact;
